import React from 'react';
import * as Sentry from '@sentry/react';
import { FavoriteIcon } from './components/favoriteIcon';
import { useFacilityFavoriteRecreations } from './hooks';

const FAVORITE_LIST_PATH = '/customers/favorite_recreations';

export const FacilityFavoriteRecreation: React.FC<{
  recreationId: number;
  initialIsFavorite: boolean;
  initialFavoriteId: number | null;
}> = ({ recreationId, initialIsFavorite, initialFavoriteId }) => {
  const [isFavorite, setIsFavorite] = React.useState<boolean>(initialIsFavorite);
  const [favoriteId, setFavoriteId] = React.useState<number | null>(initialFavoriteId);
  // state だと再レンダー前の連打を弾けず、同じレクへの登録リクエストが二重に飛ぶ
  const isProcessingRef = React.useRef<boolean>(false);
  const { createFavoriteRecreation, deleteFavoriteRecreation } =
    useFacilityFavoriteRecreations();

  const handleClick = async (): Promise<void> => {
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;

    try {
      if (isFavorite && favoriteId) {
        await deleteFavoriteRecreation(favoriteId);

        // NOTE: お気に入り一覧ページにいる場合はリロードして一覧を更新する。画面が差し替わるまで再クリックさせないためロックは解除しない
        if (window.location.pathname === FAVORITE_LIST_PATH) {
          window.location.reload();
          return;
        }

        setIsFavorite(false);
        setFavoriteId(null);
      } else {
        const result = await createFavoriteRecreation(recreationId);
        setIsFavorite(true);
        setFavoriteId(result.id);
      }
    } catch (e) {
      Sentry.captureException(e);
      alert('お気に入りの更新に失敗しました。時間をおいて再度お試しください');
    }
    isProcessingRef.current = false;
  };

  return <FavoriteIcon isFavorite={isFavorite} onClick={handleClick} />;
};
